import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import './Contact.scss';

const Contact = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    companySize: '',
    phone: '',
    organization: '',
    inquiryTopic: '',
    message: ''
  });

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // Handle form submission
    console.log('Form submitted:', formData);
  };

  return (
    <div className="contact">
      {/* Hero Section */}
      <div className="contact__hero">
        <div className="contact__hero-overlay"></div>
        <div className="container">
          <h1 className="contact__title">Get in Touch</h1>
          <p className="contact__subtitle">We'd love to hear from you</p>
        </div>
      </div>

      {/* Main Content */}
      <div className="container">
        <div className="contact__content">
          {/* Left Column - Contact Info */}
          <div className="contact__info">
            <h2>Contact Information</h2>
            <p className="contact__welcome">
              Have questions about our AI solutions? We're here to help. Reach out to us through any of the following channels.
            </p>

            <div className="contact__details">
              <div className="contact__detail-item">
                <i className="icon-email"></i>
                <div>
                  <h3>Email</h3>
                  <a href="mailto:info@skil.ai">info@skil.ai</a>
                </div>
              </div>

              <div className="contact__detail-item">
                <i className="icon-phone"></i>
                <div>
                  <h3>Phone</h3>
                  <a href="tel:+1234567890">+1 (234) 567-890</a>
                </div>
              </div>

              <div className="contact__detail-item">
                <i className="icon-location"></i>
                <div>
                  <h3>New Jersey Office</h3>
                  <p>123 Tech Park, Suite 456<br />Newark, NJ 07101</p>
                </div>
              </div>

              <div className="contact__detail-item">
                <i className="icon-location"></i>
                <div>
                  <h3>Visakhapatnam Office</h3>
                  <p>456 Digital Hub, Floor 7<br />Visakhapatnam, AP 530003</p>
                </div>
              </div>
            </div>
          </div>

          {/* Right Column - Contact Form */}
          <div className="contact__form-container">
            <h2>Send Us a Message</h2>
            <form className="contact__form" onSubmit={handleSubmit}>
              <div className="form-group">
                <label htmlFor="name">Full Name *</label>
                <input
                  type="text"
                  id="name"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  required
                />
              </div>

              <div className="form-group">
                <label htmlFor="email">Email Address *</label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  required
                />
              </div>

              <div className="form-group">
                <label htmlFor="companySize">Company Size</label>
                <select
                  id="companySize"
                  name="companySize"
                  value={formData.companySize}
                  onChange={handleChange}
                >
                  <option value="">Select company size</option>
                  <option value="1-10">1-10 employees</option>
                  <option value="11-50">11-50 employees</option>
                  <option value="51-200">51-200 employees</option>
                  <option value="201-500">201-500 employees</option>
                  <option value="501+">501+ employees</option>
                </select>
              </div>

              <div className="form-group">
                <label htmlFor="phone">Phone Number</label>
                <input
                  type="tel"
                  id="phone"
                  name="phone"
                  value={formData.phone}
                  onChange={handleChange}
                />
              </div>

              <div className="form-group">
                <label htmlFor="organization">Organization</label>
                <input
                  type="text"
                  id="organization"
                  name="organization"
                  value={formData.organization}
                  onChange={handleChange}
                />
              </div>

              <div className="form-group">
                <label htmlFor="inquiryTopic">Inquiry Topic *</label>
                <select
                  id="inquiryTopic"
                  name="inquiryTopic"
                  value={formData.inquiryTopic}
                  onChange={handleChange}
                  required
                >
                  <option value="">Select a topic</option>
                  <option value="general">General Inquiry</option>
                  <option value="sales">Sales</option>
                  <option value="support">Technical Support</option>
                  <option value="partnership">Partnership</option>
                  <option value="other">Other</option>
                </select>
              </div>

              <div className="form-group">
                <label htmlFor="message">Message *</label>
                <textarea
                  id="message"
                  name="message"
                  value={formData.message}
                  onChange={handleChange}
                  required
                  rows="4"
                ></textarea>
              </div>

              <div className="form-group">
                <div className="g-recaptcha" data-sitekey="your-site-key"></div>
              </div>

              <button type="submit" className="button button--primary">
                Submit Now
              </button>
            </form>
          </div>
        </div>

        {/* Map Section */}
        <div className="contact__map">
          <iframe
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3022.9663095343008!2d-74.00425878428698!3d40.71277937933185!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x89c25a165bedccab%3A0x2cb2ddf003b5ae01!2sNew%20York%2C%20NY%2C%20USA!5e0!3m2!1sen!2s!4v1647043082973!5m2!1sen!2s"
            width="100%"
            height="450"
            style={{ border: 0 }}
            allowFullScreen=""
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
          ></iframe>
        </div>
      </div>
    </div>
  );
};

export default Contact; 